var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSearchClose = function SvgSearchClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m9.071 10-8.57 8.571L1.928 20l8.571-8.571L19.071 20l1.429-1.429L11.929 10 20.5 1.429 19.071 0 10.5 8.571 1.929.001.5 1.428 9.071 10Z",
    fill: "#F7F9FA"
  })));
};

export { SvgSearchClose as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMSAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05LjA3MTQ2IDEwTDAuNTAwMTIyIDE4LjU3MTRMMS45Mjg2OCAxOS45OTk5TDEwLjUgMTEuNDI4NkwxOS4wNzE0IDIwTDIwLjUgMTguNTcxNEwxMS45Mjg2IDEwTDIwLjUgMS40Mjg2NUwxOS4wNzE0IDkuNDM2NTFlLTA1TDEwLjUgOC41NzE0OUwxLjkyODY5IDAuMDAwMTUzMjU2TDAuNTAwMTI1IDEuNDI4NzFMOS4wNzE0NiAxMFoiIGZpbGw9IiNGN0Y5RkEiLz4KPC9zdmc+Cg==";